import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { useAcaDocumentsQuery } from 'queries';
import { AcaDocument } from './components';
import { InternalPage, HomeLink, Spacer } from 'theSource/components';
import {
  CardContentStyled,
  CardStyled,
  TitleLabelStyled,
} from './AcaDocumentsStyled';
import { ROUTES } from 'enrollment/app/routes';

export const AcaDocuments = () => {
  const { t } = useTranslation('pages.acaDocuments');

  const { data: acaData } = useAcaDocumentsQuery({ enabled: true });

  const acaDocuments = acaData?.data ?? [];

  const sortedAcaDocuments = [...acaDocuments].sort((a, b) => {
    const taxYearA = Number(a.year);
    const taxYearB = Number(b.year);
    return taxYearB - taxYearA;
  });

  const hasPaperReductionActDisclaimer = acaData?.acaPaperReductionActDisclaimer
    ? acaData.acaPaperReductionActDisclaimer.trim() !== ''
    : false;

  return (
    <InternalPage
      testId="tax-documents-page"
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <Spacer height={4} />
      <h1>{t('title')}</h1>
      <p>{t('description')}</p>
      {hasPaperReductionActDisclaimer ? (
        <>
          <CardStyled data-testid="pra-disclaimer-card">
            <CardContentStyled>
              <TitleLabelStyled className="headline-3 border-bottom">
                {t('pra_disclaimer_header')}
              </TitleLabelStyled>
              <Typography variant="body3">
                {acaData.acaPaperReductionActDisclaimer}{' '}
                <Link
                  to={ROUTES.enrollment.profileEdit.path}
                  className="text-decoration-underline"
                >
                  {t('pra_disclaimer_link')}
                </Link>
              </Typography>
            </CardContentStyled>
          </CardStyled>
        </>
      ) : (
        <></>
      )}
      <Spacer height={2} />
      {acaDocuments.length > 0 ? (
        <div className="my-4">
          <h3>{t('listHeader')}</h3>
          <div className="card">
            {sortedAcaDocuments?.map((document, index) => (
              <AcaDocument
                key={index}
                document={document}
                isCurrent={index === 0}
              />
            ))}
          </div>
        </div>
      ) : (
        <></>
      )}
    </InternalPage>
  );
};
